import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import { useTheme } from '../contexts/ThemeContext';

const NotFoundPage = () => {
  const { isDarkMode } = useTheme();

  return (
    <div className={`
      min-h-screen flex flex-col items-center justify-center 
      ${isDarkMode ? 'bg-gray-900 text-gray-200' : 'bg-gray-100 text-gray-800'}
      px-4 py-8
    `}>
      <div className={`
        max-w-md w-full 
        ${isDarkMode ? 'bg-gray-800' : 'bg-white'}
        rounded-xl shadow-2xl p-8 text-center
      `}>
        <div className="flex justify-center mb-6">
          <ExclamationTriangleIcon 
            className={`
              h-20 w-20 
              ${isDarkMode ? 'text-yellow-500' : 'text-yellow-600'}
            `} 
          />
        </div>
        
        <h1 className={`
          text-4xl font-bold mb-4
          ${isDarkMode ? 'text-gray-200' : 'text-gray-900'}
        `}>
          404 - Page Not Found
        </h1>
        
        <p className={`
          mb-6 
          ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}
        `}>
          Oops! The page you are looking for seems to have gone missing.
        </p>
        
        <div className="flex justify-center space-x-4">
          <Link 
            to="/dashboard" 
            className={`
              px-6 py-3 rounded-lg transition duration-300
              ${isDarkMode 
                ? 'bg-blue-600 text-white hover:bg-blue-500' 
                : 'bg-blue-500 text-white hover:bg-blue-600'
              }
            `}
          >
            Go to Dashboard
          </Link>
          
          <Link 
            to="/" 
            className={`
              px-6 py-3 rounded-lg transition duration-300
              ${isDarkMode 
                ? 'bg-gray-700 text-gray-300 hover:bg-gray-600' 
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }
            `}
          >
            Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
